export default __webpack_public_path__ + "static/media/not-found.2e9db55b.png";